export function gerarFilenameGrafico(name: string) {
	return `${name}_exportado em_${new Date()
		.toLocaleDateString()
		.replaceAll('/', '_')}`
		.normalize('NFD')
		.replace(/\p{Diacritic}/gu, '');
}
